<shortcut-menu [subscription]="subscription()">
  <malfunction-item [subscription]="subscription()" [messages]="activities()" />
  <send-config-item [subscriptionId]="subscription().subscriptionId" />
  <forti-manager-item />
  <forti-analyzer-item />
  <service-documentation-item [url]="serviceDocumentationUrl" />
</shortcut-menu>
